import { Controller } from '@hotwired/stimulus'

// Generic confirm dialog. data-controller goes on an ancestor shared by
// the trigger and the dialog (dialogTarget). Input target (optional)
// gates submit on matching its data-expected-value.
export default class extends Controller {
  static targets = ['dialog', 'input', 'submit', 'frame']

  connect() {
    this._onClose = () => this.#reset()
    this.dialogTarget.addEventListener('close', this._onClose)
  }

  disconnect() {
    this.dialogTarget.removeEventListener('close', this._onClose)
  }

  open() {
    // A lazy turbo-frame only fetches once; force a refetch each time the
    // dialog opens so it doesn't show whatever was left over from the
    // previous time it was open (e.g. a finished progress bar).
    if (this.hasFrameTarget) this.frameTarget.src = this.frameTarget.src
    this.dialogTarget.showModal()
  }

  // Accepts an optional click event so a real <a href> can double as a
  // fallback (native navigation) when there's no dialog to close.
  close(event) {
    event?.preventDefault()
    this.dialogTarget.close()
  }

  check() {
    this.submitTarget.disabled = this.inputTarget.value !== this.inputTarget.dataset.expectedValue
  }

  #reset() {
    if (!this.hasInputTarget) return
    this.inputTarget.value = ''
    this.submitTarget.disabled = true
  }
}
